export const tr = {
    archive: 'Tüm arşiv',
    load: 'Daha fazla göster'
};
